import React from 'react';
import axios from 'axios';
import {toast} from "react-toastify";
import Notiflix from "notiflix-react";


class UserRegisterBracBank extends React.Component {

    constructor(props) {
        super(props)
        this.state = {         
            username: '',
            password: '',
            name: '',
            email: '',
            phone: '',
            organization: ''
        }
    }

    handleChange = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        this.setState({
            [name]: value
        });
    }

    handleSubmit = (event) => {
        Notiflix.Loading.Circle();
        const key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
        const url = `${localStorage.apiHost}/user-registration`;
        let data = JSON.stringify({
            'username': 'brac_' + Date.now().toString(36) + Math.random().toString(36).substr(2),
            'password': 'brac123456',
            'name': this.state.name,
            'email': this.state.email,
            'phone': this.state.phone,
            'organization': this.state.organization,
            'program-id': localStorage.programId,
        });
        axios({
            method: 'post',
            url: url,
            data: data,
            headers: {
                'key': key,
                "Content-Type" : "application/json"
            }

        }).then(response => {

            console.log(response.data);
            Notiflix.Loading.Remove();

            if (response.data.status === 200) {
                localStorage.token = response.headers.token;
                localStorage.isLogin = "true";
                localStorage.userName = response.data.name;
                this.props.onClick('true', response.data.name);
                toast.success(response.data.message);
                    
            }else{
                toast.error(response.data.message);
                localStorage.isLogin = "false";
                this.props.onClick('false', '');
            }
        });
        event.preventDefault();
    }


    render() {

        return (
                <div className="py-1">
                   <form onSubmit={this.handleSubmit} autoComplete="off">

                        {/* <div className="form-group">
                            <label>Username:  <span className="text-danger">*</span> <br></br><span className="label-eg">(Letters & numbers only. E.g. iamuser12, mrkamal5 etc.)</span></label>
                            <input id="login-id" pattern="^[a-zA-Z0-9\-_]{0,40}$" title="Letters & numbers only. No space & no special characters." autoComplete="off" onChange={this.handleChange} type="text" className="form-control" name="username" placeholder="Enter Your Username" required></input>
                        </div>

                        <div className="form-group mt-3">
                            <label>Password  <span className="text-danger">*</span> <br></br><span className="label-eg">(Uppercase/lowercase letters, numbers, special characters. E.g. dAbM3#89, LhG34@qw etc.)</span></label>
                            <input id="pass" type="password" onChange={this.handleChange}className="form-control" name="password" placeholder="Password" required></input>
                        </div> */}

                        <div className="form-group">
                            <label>Full Name <span className="text-danger">*</span> <span className="label-eg">(E.g. Md. Zamal Uddin, Abdur Rahman)</span></label>
                            <input onChange={this.handleChange} name="name" type="text" className="form-control"  placeholder="Enter Your Full Name" required></input>
                        </div>
                        
                        <div className="form-group mt-3">
                            <label>Email <span className="text-danger">* </span><span className="label-eg">(One email can be used for one registration.)</span></label>
                            <input id="email" onChange={this.handleChange} type="email" className="form-control" name="email" placeholder="Enter Your Email" required></input>
                        </div>                       

                        
                        <div className="form-group mt-3">
                            <label>Phone <br></br> <span className="label-eg">(Complete mobile number with country code. E.g. +8801822112233 etc.)</span></label>
                            <input onChange={this.handleChange} id="phone" type="text" className="form-control" name="phone" placeholder="Enter Your Phone"></input>
                        </div>
                        
                        <div className="form-group mt-3">
                            <label>Organization <span className="text-danger">*</span> </label>
                            <input onChange={this.handleChange} id="organization" type="text" className="form-control" name="organization" placeholder="Enter Your Organization" required></input>
                        </div>

                        <button type="submit" className="btn btn-md btn-info mt-3">Register</button>

                    </form>
                    
                    {/* <hr></hr>
                    <h5 className='text-right'>Already have an account?</h5>                    
                    <p className='text-right'> &nbsp; 
                        <a className={`btn btn-lg btn-primary btn-round`} data-toggle="modal" data-target="#login" style={{background: localStorage.loginBtnBgColor, color:localStorage.loginBtnTextColor, border: 'none'}}>
                            Login
                        </a>
                    </p> */}
                        
                </div>
        );
    }
}

export default UserRegisterBracBank;